import { render, staticRenderFns } from "./AssociatedMaterial.vue?vue&type=template&id=e3086c6a&scoped=true"
import script from "./AssociatedMaterial.vue?vue&type=script&lang=js"
export * from "./AssociatedMaterial.vue?vue&type=script&lang=js"
import style0 from "./AssociatedMaterial.vue?vue&type=style&index=0&id=e3086c6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3086c6a",
  null
  
)

export default component.exports